export default {
      id: "small-left-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "sprite.svg#small-left",
      toString: function () {
        return this.url;
      }
    }